function toVal(mix: ClassValue) {
  if (typeof mix === 'string') {
    return mix;
  } else if (typeof mix === 'object' && mix !== null) {
    return Object.keys(mix)
      .filter((key) => mix[key])
      .join(' ');
  } else {
    return false;
  }
}

export type ClassValue = ClassDictionary | string | null | undefined;

export type ClassDictionary = Record<string, boolean | undefined | null>;

export function cls(...classes: ClassValue[]) {
  return classes.map(toVal).filter(Boolean).join(' ');
}
